<div class="status offline" *ngIf="!online">
   <div class="signal"></div>
   {{ "status-indicator.offline" | i18next }}
</div>
